import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import FormFieldValidationError from "../../../Common/FormFieldValidationError/FormFieldValidationError";
import "./UserAddNewAddress.css";
import "../../../Common/Common.css";
import {FormattedMessage} from "react-intl";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import axios from "axios";

const jpCharacterPattern = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
class UserAddNewAddress extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userId: this.props.userId,
            show: false,

            addressLine2: "",
            cellOrMobileNumber: "",
            city: "",
            companyName: "",
            firstName: "",
            lastName: "",
            postalCode: "",
            province: "",
            streetAddress: "",
            country: "日本",
            japaneseFirstName: "",
            japaneseLastName: "",

            countryValidationError: "",
            cellOrMobileNumberValidationError: "",
            cityValidationError: "",
            companyNameValidationError: "",
            firstNameValidationError: "",
            lastNameValidationError: "",
            jpFirstNameValidationError: "",
            jpLastNameValidationError: "",
            postalCodeValidationError: "",
            provinceValidationError: "",
            streetAddressValidationError: "",
            shipping: false,
            billing: false,
            addressType: []
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onInputChange = this.onInputChange.bind(this);

        this.validateCountry = this.validateCountry.bind(this);
        this.validateCellOrMobileNumber = this.validateCellOrMobileNumber.bind(this);
        this.validateCity = this.validateCity.bind(this);
        this.validateCompanyName = this.validateCompanyName.bind(this);
        this.validateFirstName = this.validateFirstName.bind(this);
        this.validateLastName = this.validateLastName.bind(this);
        this.validateJapaneseLName = this.validateJapaneseLName.bind(this);
        this.validateJapaneseFName = this.validateJapaneseFName.bind(this);
        this.validatePostalCode = this.validatePostalCode.bind(this);
        this.validateProvince = this.validateProvince.bind(this);
        this.validateStreetAddress = this.validateStreetAddress.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onShippingStateChange = this.onShippingStateChange.bind(this);
        this.onBillingStateChange = this.onBillingStateChange.bind(this);
    }

    handleClose = () => {
        this.setState({
            show: false,

            country: "",
            addressLine2: "",
            cellOrMobileNumber: "",
            city: "",
            companyName: "",
            firstName: "",
            lastName: "",
            postalCode: "",
            province: "",
            streetAddress: "",
            japaneseFirstName: "",
            japaneseLastName: "",

            countryValidationError: "",
            cellOrMobileNumberValidationError: "",
            cityValidationError: "",
            companyNameValidationError: "",
            firstNameValidationError: "",
            lastNameValidationError: "",
            postalCodeValidationError: "",
            provinceValidationError: "",
            streetAddressValidationError: "",
            jpFirstNameValidationError: "",
            jpLastNameValidationError: "",
        });
    };

    handleShow = () => {
        this.setState({show: true});
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,

            countryValidationError: "",
            cellOrMobileNumberValidationError: "",
            cityValidationError: "",
            companyNameValidationError: "",
            firstNameValidationError: "",
            lastNameValidationError: "",
            postalCodeValidationError: "",
            provinceValidationError: "",
            streetAddressValidationError: "",
            jpFirstNameValidationError: "",
            jpLastNameValidationError: "",

        });
    };
    onSelectChange = (event) => {
        this.setState({
            country: event.value,
            countryValidationError: "",
            cellOrMobileNumberValidationError: "",
            cityValidationError: "",
            companyNameValidationError: "",
            firstNameValidationError: "",
            lastNameValidationError: "",
            postalCodeValidationError: "",
            provinceValidationError: "",
            streetAddressValidationError: "",
            jpFirstNameValidationError: "",
            jpLastNameValidationError: "",
        });
    };

    fullWidthNumConvert(fullWidthNum) {
        var rex = /[\uFF10-\uFF19]/g;
        fullWidthNum = fullWidthNum.replace(rex, function(ch) {
            return String.fromCharCode(ch.charCodeAt(0) - 65248);
        });

        fullWidthNum = fullWidthNum.replace(/\s/g, '');
        fullWidthNum = fullWidthNum.replace(/\u3002/g, ".");
        return fullWidthNum;
    };

    validateFirstName = () => {
        let firstName = this.state.firstName;// Field name
        if (firstName === "") {
            this.setState({
                firstNameValidationError: "First Name を入力してください。"
            });
            return false;
        }
        return true;
    };
    validateLastName = () => {
        let lastName = this.state.lastName;
;        if (lastName === "") {
            this.setState({
                lastNameValidationError: "Last Name を入力してください。"
            });
            return false;
        }
        return true;
    };
    validateCompanyName = () => {
        let companyName = this.state.companyName; // Field name
;        if (companyName === "") {
            this.setState({
                companyNameValidationError: "会社名を入力してください。"
            });
            return false;
        }
        return true;
    };
    validateCellOrMobileNumber = () => {
        let cellOrMobileNumber = this.fullWidthNumConvert(this.state.cellOrMobileNumber); // Field name
;        if (cellOrMobileNumber === "") {
            this.setState({
                cellOrMobileNumberValidationError: "電話番号を入力してください。"
            });
            return false;
        }
        return true;
    };
    validateCity = () => {
        let city = this.state.city; // Field name
;        if (city === "") {
            this.setState({
                cityValidationError: "市区町村を入力してください。"
            });
            return false;
        }
        return true;
    };
    validateProvince = () => {
        let province =this.state.province; // Field name
;        if (province === "") {
            this.setState({
                provinceValidationError: "都道府県を入力してください。"
            });
            return false;
        }
        return true;
    };
    validateStreetAddress = () => {
        let streetAddress = this.state.streetAddress; // Field name
;        if (streetAddress === "") {
            this.setState({
                streetAddressValidationError: "住所を入力してください。"
            });
            return false;
        }
        return true;
    };

    validatePostalCode = () => {
        let postalCode = this.fullWidthNumConvert(this.state.postalCode); // Field name
        postalCode = postalCode.replace(/\u30FC/g, "-");
;        let pattern = /^([0-9]{3})(?:[-\s]*([0-9]{4}))?$/; //validated
        if (postalCode === "" || !postalCode.match(pattern)) {
            this.setState({
                postalCodeValidationError: "郵便番号を入力してください。"
            });
            return false;
        }
        return true;
    };

    validateJapaneseFName = () => {
        let firstName = this.state.japaneseFirstName; // Field name
        if (firstName === "") {
            this.setState({
                jpFirstNameValidationError: "名を入力してください。"
            });
            return false;
        }
        return true;
    };

    validateJapaneseLName = () => {
        let lastName = this.state.japaneseLastName; // Field name
        if (lastName === "") {
            this.setState({
                jpLastNameValidationError: "姓をを入力してください。"
             });
            return false;
        }
        return true;
    };

    validateCountry = () => {
        let country = this.state.country; // Field name

        if(country !== ""){
            this.setState({
                cityValidationError : "国を入力してください。"
            })
        }
        return true;
    };

    saveAddress = () => {
        let {shipping, billing} = this.state;
        let addressType = [];
        if (shipping) {
            addressType.push("SHIPPING")
        }
        if (billing) {
            addressType.push("BILLING")
        }
        axios.post(RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/addresses'
            , {
                name: this.state.name,
                phone: this.state.contact,
                address: this.state.address,

                addressLine2: this.state.addressLine2,
                cellOrMobileNumber: this.state.cellOrMobileNumber,
                city: this.state.city,
                companyName: this.state.companyName,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                postalCode: this.state.postalCode,
                province: this.state.province,
                streetAddress: this.state.streetAddress,
                country: "日本",
                addressType: addressType,
                japaneseFirstName: this.state.japaneseFirstName,
                japaneseLastName: this.state.japaneseLastName
            })
            .then((res) => {
                // console.log("New address saved", res);
                this.props.getUserAddresses(this.props.userId);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    onShippingStateChange = () => {
        this.setState({
            shipping: !this.state.shipping
        });
    };
    onBillingStateChange = () => {
        this.setState({
            billing: !this.state.billing
        });
    };

    onSubmit = event => {


        // let countryOk = this.validateCountry();
        let countryOk = true;
        let validateCellOrMobileNumberOk = this.validateCellOrMobileNumber();
        let validateCityOk = this.validateCity();
        let validateCompanyNameOk = true;
        let validateFirstNameOk = this.validateFirstName();
        let validateJpFirstNameOk = this.validateJapaneseFName();
        let validateLastNameOk = this.validateLastName();
        let validateJpLastNameOk = this.validateJapaneseLName();
        let validatePostalCodeOk = this.validatePostalCode();
        let validateProvinceOk = this.validateProvince();
        let validateStreetAddressOk = this.validateStreetAddress();


        if (countryOk && validateCellOrMobileNumberOk && validateCityOk && validateJpFirstNameOk && validateJpLastNameOk &&
            validateCompanyNameOk && validateFirstNameOk && validateFirstNameOk && validateLastNameOk &&
            validatePostalCodeOk && validateProvinceOk && validateStreetAddressOk) {
            this.saveAddress();
            this.handleClose();
        }

    };

    render() {
        const options = [

            {
                value: 'jp',
                label: <FormattedMessage id="app.user-profile.user-add-address.country-opt1"
                                         defaultMessage="Japan"
                                         description=""/>
            }
        ];

        return (
            <span>
                <a className="btn btn-xs btn-success user-profile-btn" onClick={this.handleShow}>
                     <FormattedMessage id="app.user-profile.user-add-address.add-button-text"
                                       defaultMessage="Add New"
                                       description=""
                     />
                </a>

                <Modal dialogClassName="new-address-modal" show={this.state.show} onHide={this.handleClose}>
                    <form>
                        <Modal.Header closeButton>
                            <div className="row no-padding">
                                 <span className="title-1 color-text">
                                    <FormattedMessage id="app.user-profile.user-add-address.title"
                                                      defaultMessage="ADD NEW ADDRESS"
                                                      description=""
                                    />
                                 </span>
                                &nbsp;
                                <span className="required-label">
                                    <b>
                                        <FormattedMessage id="app.user-profile.user-add-address.caption"
                                                          defaultMessage="(”姓””名”以外は全てローマ字入力して下さい。[必須]項目は全て入力する必要があります。)"
                                                          description=""
                                        />
                                    </b>
                                </span>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="add-new-address-div color-text">
                                <div className="address-resp-content">
                                     <div className="row">
                                          {/*<div className="col-md-2">&nbsp;</div>*/}
                                          <div className="col-md-5 no-padding text-left">
                                              <input
                                                  type="checkbox"
                                                  name="shipping"
                                                  value={this.state.shipping}
                                                  checked={this.state.shipping}
                                                  onChange={this.onShippingStateChange}/>
                                              &nbsp;
                                              <span className="agreement">
                                        <FormattedMessage id="app.user-profile.user-add-address.mark-shipping"
                                                          defaultMessage="Mark as shipping address"
                                                          description=""/>

                                    </span>
                                          </div>
                                          <div className="col-md-5 no-padding text-left">
                                               <input
                                                   type="checkbox"
                                                   name="billing"
                                                   value={this.state.billing}
                                                   checked={this.state.billing}
                                                   onChange={this.onBillingStateChange}/>
                                              &nbsp;
                                              <span className="agreement">
                                        {this.state.billing ? "請求先住所として設定する。" : "請求先住所として設定する。"}

                                                  {/*<FormattedMessage id="app.user-profile.user-add-address.mark-billing"*/}
                                                  {/*defaultMessage="Mark as billing address"*/}
                                                  {/*description=""/>*/}
                                    </span>
                                          </div>
                                      </div>
                                     <div className="row spacer"></div>
                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                            <div className="no-padding col-md-4 user-profile-model-custom-col-1 user-profile-model-custom-col-1 text-left-col data-label">
                                                    <FormattedMessage id="app.user-profile.user-add-address.country"
                                                                      defaultMessage="Country(国)"
                                                                      description=""/>
                                            </div>
                                            <div className="col-md-8 user-profile-model-custom-col-2">

                                                <FormattedMessage id="app.user-profile.user-add-address.country-opt1"
                                                                  defaultMessage="Japan"
                                                                  description=""/>

                                                <p className="error-message"> {this.state.countryValidationError}</p>
                                            </div>
                                        </div>
                                        <div className="col-md-6 no-padding">&nbsp;</div>
                                    </div>
                                    <div className="row spacer"></div>

                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                                <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                  <FormattedMessage id="app.user-profile.user-add-address.company-name"
                                                                    defaultMessage="Company Name(会社名）"
                                                                    description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                  <input type="text" name="companyName" value={this.state.companyName}
                                                         className="form-control input-sm input-width-user-address"
                                                         onChange={this.onInputChange}/>

                                                  <p className="error-message"> {this.state.companyNameValidationError}</p>

                                                </div>
                                                <div
                                                    className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">RIZEN　HONGKONG　LTD</div>
                                        </div>
                                    </div>
                                    <div className="row spacer"></div>

                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                             <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                <span className="required-label">[必須]</span>
                                                    <FormattedMessage id="app.user-profile.user-add-address.last-name"
                                                                      defaultMessage="Last Name"
                                                                      description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                    <input type="text" name="lastName" value={this.state.lastName}
                                                           className="form-control input-sm input-width-user-address"
                                                           onChange={this.onInputChange}/>

                                                <p className="error-message"> {this.state.lastNameValidationError}</p>
                                                </div>
                                            <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">Yamada</div>
                                        </div>
                                        <div className="col-md-6 no-padding">
                                              <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                  <span className="required-label">[必須]</span>
                                                   <FormattedMessage id="app.user-profile.user-add-address.first-name"
                                                                     defaultMessage="First Name"
                                                                     description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                    <input type="text" name="firstName" value={this.state.firstName}
                                                           className="form-control input-sm input-width-user-address"
                                                           onChange={this.onInputChange}/>

                                                <p className="error-message"> {this.state.firstNameValidationError}</p>

                                                </div>
                                                <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">Taro</div>
                                        </div>
                                     </div>
                                    <div className="row spacer"></div>

                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                             <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                 <span className="required-label">[必須]</span>
                                                    <FormattedMessage
                                                        id="app.user-profile.user-add-address.last-name-jp"
                                                        defaultMessage="姓"
                                                        description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                    <input type="text" name="japaneseLastName"
                                                           value={this.state.japaneseLastName}
                                                           className="form-control input-sm input-width-user-address"
                                                           onChange={this.onInputChange}/>

                                                <p className="error-message"> {this.state.jpLastNameValidationError}</p>

                                                </div>
                                            <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">山田</div>
                                        </div>
                                        <div className="col-md-6 no-padding">
                                              <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                  <span className="required-label">[必須]</span>
                                                   <FormattedMessage
                                                       id="app.user-profile.user-add-address.first-name-jp"
                                                       defaultMessage="名"
                                                       description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                    <input type="text" name="japaneseFirstName"
                                                           value={this.state.japaneseFirstName}
                                                           className="form-control input-sm input-width-user-address"
                                                           onChange={this.onInputChange}/>

                                                <p className="error-message"> {this.state.jpFirstNameValidationError}</p>

                                                </div>
                                            <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">太郎</div>

                                        </div>
                                     </div>
                                    <div className="row spacer"></div>

                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                            <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                <span className="required-label">[必須]</span>
                                                   <FormattedMessage id="app.user-profile.user-add-address.postal"
                                                                     defaultMessage="Zip code(郵便番号）"
                                                                     description=""/>
                                               </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2  text-left">
                                                   <input type="text" name="postalCode" value={this.state.postalCode}
                                                          className="form-control input-sm input-width-user-address"
                                                          onChange={this.onInputChange}/>


                                                   <p className="error-message"> {this.state.postalCodeValidationError}</p>


                                                </div>
                                            <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">560-1235</div>
                                             </div>
                                    </div>
                                    <div className="row spacer"></div>

                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                                <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                    <span className="required-label">[必須]</span>
                                                         <FormattedMessage
                                                             id="app.user-profile.user-add-address.address-line2"
                                                             defaultMessage="State(都道府県)"
                                                             description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                        <input type="text" name="province"
                                                               value={this.state.province}
                                                               className="form-control input-sm input-width-user-address"
                                                               onChange={this.onInputChange}/>

                                                   <p className="error-message"> {this.state.provinceValidationError}</p>

                                                </div>
                                            <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">Osaka</div>
                                        </div>
                                        <div className="col-md-6 no-padding">
                                           <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                               <span className="required-label">[必須]</span>
                                              <FormattedMessage id="app.user-profile.user-add-address.city"
                                                                defaultMessage="City(市区町村)"
                                                                description=""/>
                                           </div>
                                            <div className="col-md-5 user-profile-model-custom-col-2 ">
                                               <input type="text" name="city" value={this.state.city}
                                                      className="form-control input-sm input-width-user-address"
                                                      onChange={this.onInputChange}/>

                                                   <p className="error-message"> {this.state.cityValidationError}</p>

                                            </div>
                                            <div className="col-md-3  user-profile-model-custom-col-3 text-left address-samples">Chuo-ku</div>
                                        </div>
                                    </div>
                                    <div className="row spacer"></div>

                                    <div className="row">
                                        <div className="col-md-6 no-padding">
                                            <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                <span className="required-label">[必須]</span>
                                               <FormattedMessage id="app.user-profile.user-add-address.province"
                                                                 defaultMessage="Address 1(丁目番地号)"
                                                                 description=""/>
                                           </div>
                                            <div className="col-md-5 user-profile-model-custom-col-2 ">
                                               <input type="text" name="streetAddress" value={this.state.streetAddress}
                                                      className="form-control input-sm input-width-user-address" onChange={this.onInputChange}/>

                                            <p className="error-message"> {this.state.streetAddressValidationError}</p>


                                            </div>
                                            <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">#101 5-6-7</div>
                                        </div>
                                        <div className="col-md-6 no-padding">
                                                <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                       {/* <FormattedMessage
                                                            id="app.user-profile.user-add-address.street-name"
                                                            defaultMessage="Address 2(マンション名部屋番号等）"
                                                            description=""/>*/}
                                                    Address 2<br/>
                                            (マンション名・部屋番号)
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2 ">
                                                       <input type="text" name="addressLine2"
                                                              value={this.state.addressLine2}
                                                              className="form-control input-sm input-width-user-address"
                                                              onChange={this.onInputChange}/>
                                                </div>
                                             <div className="col-md-3  user-profile-model-custom-col-3 text-left address-samples">Otemae Bill</div>
                                             </div>
                                    </div>
                                    <div className="row spacer"></div>

                                     <div className="row">
                                         <div className="col-md-6 no-padding">
                                                   <div className="no-padding col-md-4 user-profile-model-custom-col-1 text-left-col data-label">
                                                       <span className="required-label">[必須]</span>
                                                   <FormattedMessage id="app.user-profile.user-add-address.contact"
                                                                     defaultMessage="Phone Number(電話番号)"
                                                                     description=""/>
                                                </div>
                                                <div className="col-md-5 user-profile-model-custom-col-2  text-left">
                                                   <input type="text" name="cellOrMobileNumber"
                                                          value={this.state.cellOrMobileNumber}
                                                          className="form-control input-sm input-width-user-address"
                                                          onChange={this.onInputChange}
                                                          maxLength={11}/>

                                                        <p className="error-message"> {this.state.cellOrMobileNumberValidationError}</p>


                                                </div>
                                             <div className="col-md-3 user-profile-model-custom-col-3  text-left address-samples">06123456789</div>
                                             </div>
                                    </div>

                                    <div className="row spacer"></div>
                                 </div>
                             </div>




                        </Modal.Body>
                        <Modal.Footer>
                            <div className="add-new-address-div edit-address-div-footer-resp">
                                <div className="col-md-9">
                                    <span className="address-caption">
                                        ※ ご住所は正しく入力してください、不足や誤りがあると商品のお届けができない場合があります。
                                </span>
                                    <br/>
                                <span className="address-caption user-address-input-padding" >
                                         新しいお届け先、請求先住所を入力する場合は、編集より追加してください。
                                 </span>
                                </div>
                                <div className="col-md-3 pull-right no-padding resp-new-address-actions">
                                    <button type="button" onClick={this.onSubmit} className="btn btn-primary bottom-button button-userAddress">
                                    <FormattedMessage id="app.user-profile.user-add-address.add-button"
                                                      defaultMessage="Add"
                                                      description=""
                                    />
                                </button>
                                <a className="btn btn-default bottom-button" onClick={this.handleClose}>
                                    <FormattedMessage id="app.user-profile.user-add-address.close-button"
                                                      defaultMessage="Close"
                                                      description=""
                                    />
                                </a>
                                </div>


                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>
            </span>
        );
    }
}

export default UserAddNewAddress;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserAddNewAddress/UserAddNewAddress.js